const mediaData = [
  {
    title: '【漫评】咒术回战为何成为现象级连载',
    desc: '深度解析咒术回战的叙事魅力与角色塑造，从漫画追更的角度带你重新认识这部作品。',
    tag: '漫评精选',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20wide%20illustration%20with%20dramatic%20lighting%20and%20manga%20panel%20composition%2C%20warm%20red%20and%20dark%20tones%2C%20editorial%20review%20style%20thumbnail%20with%20bold%20typography%20space&width=640&height=360&seq=media-review-01&orientation=landscape',
  },
  {
    title: '海贼王最终章剧情预测与追更指南',
    desc: '伟大航路即将抵达终点，海贼王最终章连载漫画剧情走向全解析。',
    tag: '追更指南',
    image: 'https://readdy.ai/api/search-image?query=Epic%20adventure%20themed%20wide%20illustration%20with%20sunrise%20over%20ocean%2C%20warm%20golden%20and%20amber%20tones%2C%20cinematic%20manga%20style%20thumbnail%20with%20dramatic%20clouds&width=640&height=360&seq=media-guide-02&orientation=landscape',
  },
  {
    title: '2025年最受期待连载漫画盘点',
    desc: '新一年值得入坑的连载漫画推荐，免费漫画全集追更计划从现在开始。',
    tag: '年度盘点',
    image: 'https://readdy.ai/api/search-image?query=Vibrant%20colorful%20wide%20illustration%20with%20manga%20cover%20collage%20aesthetic%2C%20warm%20coral%20and%20cream%20tones%2C%20playful%20editorial%20thumbnail%20style%20with%20modern%20graphic%20design&width=640&height=360&seq=media-2025-03&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 mb-3">
            漫迷墙
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            漫画深度漫评与连载漫画追更指南，漫迷创作内容精选
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {mediaData.map((item) => (
            <div
              key={item.title}
              className="bg-background-50 rounded-xl overflow-hidden hover:scale-[1.02] transition-transform cursor-pointer group"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 flex items-center justify-center bg-foreground-950/20 group-hover:bg-foreground-950/30 transition-colors">
                  <div className="w-14 h-14 rounded-full bg-background-50/90 flex items-center justify-center">
                    <i className="ri-play-fill text-2xl text-primary-500 ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-accent-500/90 text-background-50 text-[11px] font-semibold">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="font-heading text-sm font-bold text-foreground-800 mb-2">{item.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}